import { useCallback, useState } from "react";

export type TableSortOrder = "asc" | "desc";

export type TableSortState = {
  fieldName: string;
  order: TableSortOrder;
} | null;

type UseTableSortOptions = {
  onSortApplied?: () => void;
};

/** Holds table sort field/order (`null` = unsorted). Updates state on sort and optionally notifies via `onSortApplied`. */
export const useTableSort = (options?: UseTableSortOptions) => {
  const [orderBy, setOrderBy] = useState<TableSortState>(null);

  const handleSortChange = useCallback(
    (fieldName: string, order: TableSortOrder) => {
      setOrderBy({ fieldName, order });
      options?.onSortApplied?.();
    },
    [options],
  );

  return {
    orderBy,
    setOrderBy,
    handleSortChange,
  };
};
